define('controllers/auth',['require','jquery','chaplin','mediator','models/base/collection','views/site','views/messages','models/current-user','views/auth/login-form','models/auth/restoration-input','views/auth/restoration-input','models/auth/restoration-confirm','views/auth/restoration-confirm','models/auth/registration-input','views/auth/registration-input','models/auth/registration-confirm','views/auth/registration-confirm'],function(require) {

    'use strict';

    var $ = require('jquery'),
        Chaplin = require('chaplin'),
        mediator = require('mediator'),

        Collection = require('models/base/collection'),

        SiteView = require('views/site'),
        MessagesView = require('views/messages'),

        LoginModel = require('models/current-user'),
        LoginView = require('views/auth/login-form'),

        RestorationInputModel = require('models/auth/restoration-input'),
        RestorationInputView = require('views/auth/restoration-input'),

        RestorationConfirmModel = require('models/auth/restoration-confirm'),
        RestorationConfirmView = require('views/auth/restoration-confirm'),

        RegistrationInputModel = require('models/auth/registration-input'),
        RegistrationInputView = require('views/auth/registration-input'),

        RegistrationConfirmModel = require('models/auth/registration-confirm'),
        RegistrationConfirmView = require('views/auth/registration-confirm');


    var Controller = Chaplin.Controller.extend({

        beforeAction: function(){
            var _this = this;

            if (mediator.isAuthorized()) {
                return this.redirectTo('dashboard#show');
            }

            this.publishEvent('controller:actionStart');

            this.compose('site', SiteView);
            this.compose('messages', MessagesView);

            this.subscribeEvent('dispatcher:dispatch', function() {
                if (!$.active) {
                    _this.afterAction();
                } else {
                    $(document).one('ajaxStop', function() {
                        _this.afterAction();
                    });
                }
            });
        },

        afterAction: function() {
            this.publishEvent('controller:actionDone');
        },

        login: function(params){
            var model = new LoginModel(params);
            this.view = new LoginView({
                model: model,
                region: 'session'
            });
        },

        restorationInput: function(params){
            var model = new RestorationInputModel(params);
            this.view = new RestorationInputView({ model: model });
        },

        restorationConfirm: function(params){
            var model = new RestorationConfirmModel(params);
            this.view = new RestorationConfirmView({ model: model });
        },

        registrationInput: function(params){
            var model = new RegistrationInputModel(params);

            var CountryCollection = Collection.extend({ urlPath: '/api/country' });
            var TownCollection = Collection.extend({ urlPath: '/api/town', urlParams: function() { return { countryId: model.get('countryId') }; } });


            model.on('change:countryId', function() {
                model.towns.fetch();
            });

            model.countries = new CountryCollection();
            model.countries.on('sync', function() {
                model.trigger('updateCountries');
            });

            model.towns = new TownCollection();
            model.towns.on('sync', function() {
                model.trigger('updateTowns');
            });

            this.view = new RegistrationInputView({ model: model });

            model.countries.fetch();
            // model.towns.fetch();
        },

        registrationConfirm: function(params){
            var model = new RegistrationConfirmModel(params);
            this.view = new RegistrationConfirmView({ model: model });
        },
    });

    return Controller;
});

